import React, {useEffect } from "react";
import NavBar from "../MyComponents/NavBar";
import "../MyComponents/reports.css";
import { useHistory } from "react-router-dom";

export default function OrgDashboard() {
  const initialToken = localStorage.getItem("token");
  const history = useHistory();

  useEffect(() => {
    if (!initialToken) {
      history.push("/login");
    }
  }, [initialToken, history]);

  return (
    <>
      <NavBar detailView={true} />
      <div>
        <iframe
          title="org-dashboard"
          src="https://app.powerbi.com/view?r=eyJrIjoiMTI4MmMzYmYtZTExMS00NWU3LWIxMjQtOTE0Y2ZiOTUwOGJmIiwidCI6ImIyYTViZGZhLTU0MzktNGUxMy04YTBlLWRmODIwMTJiMTQ2YSIsImMiOjZ9"
          id="reports"
        ></iframe>
      </div>
    </>
  );
}
